import {appConfig} from '../app.config';
import {DialogUtils} from '@rbaip/ui-component';
import {GalleryPhoto} from './gallery-photo.model';

export class PhotoGalleryUtils {

  public static showPhotoGallery(photos: GalleryPhoto[], indexOfActivePhoto: number) {
    if (photos && indexOfActivePhoto >= 0) {
      const url = appConfig.assetManagementPortalRoot + '/photo-gallery';
      const height = window.innerHeight * 0.8;
      const width = window.innerWidth * 0.8;
      const popupOptions = 'toolbar=no,location=no,status=no,menubar=no,titlebar=no';
      const popup = DialogUtils.popupCenter(url, 'Photo Gallery', width, height, popupOptions);
      popup.window['imageList'] = JSON.stringify(photos);
      popup.window['activeImageIndex'] = indexOfActivePhoto;
    }
  }
}
